

// add class to wp-block-group when it's in viewport with observer
const groupBlocks = document.querySelectorAll('.wp-block-sticky-group .wp-block-cover');

if (groupBlocks.length) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {

      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');

        groupBlocks.forEach(block => {
          if (entry.target != block) {
            block.classList.remove('is-visible');
          }
        });
      }
    });
  }, {
    root: null, // Use the viewport as the root
    // rootMargin: "-200px",
    threshold: 0.5, // Detect when the bottom of the element intersects with the top of the viewport
  });

  let isFirstObject = true;

  groupBlocks.forEach(groupBlock => {

    // set first image to be visible as default
    if (isFirstObject) {
      groupBlock.classList.add('is-visible');
      isFirstObject = false;
    }

    observer.observe(groupBlock);
  });
}
